// An actor in the shared lightbox (`MediaPreview`; issue 828, bug 25, Daniil's request beyond
// live, as the library's, S1 decision 21): live's preview shows a team actor's portrait and a
// global actor's video; ours shows them full screen, stepping through the list it was opened
// from, with the actors' 512 px portraits in the strip, and a portrait at screen size in place
// of the file, or of a global actor's video's poster, as live's `sources.fullScreen` (issue 910).
import type { AiActor } from "../../api/generated/model";
import type { PreviewItem } from "../media/MediaPreview";
import type { PickedActor } from "./picked";

/** A team actor as live's My Actors preview shows it: its portrait, at screen size once made. */
export function portraitItem(actor: AiActor): PreviewItem {
  return {
    id: actor.id,
    name: actor.name,
    kind: "image",
    url: actor.image_url,
    view: actor.screen_url ?? null,
    thumb: actor.thumb_url ?? actor.image_url,
    poster: null,
    durationMs: null,
    width: actor.width,
    height: actor.height,
  };
}

/** A global actor as live's Global Actors preview shows it: its video, else its portrait. */
export function videoItem(actor: AiActor): PreviewItem {
  if (actor.video_url === null) return portraitItem(actor);
  return {
    ...portraitItem(actor),
    kind: "video",
    url: actor.video_url,
    poster: actor.image_url,
    durationMs: actor.duration_ms,
  };
}

/** An actor of Add Actors with a video (live's eye on its tile), keyed as the dialog keys it. */
export function pickedVideoItem(actor: PickedActor & { videoUrl: string }): PreviewItem {
  return {
    id: actor.key,
    name: actor.name,
    kind: "video",
    url: actor.videoUrl,
    thumb: actor.thumbUrl ?? actor.imageUrl,
    view: actor.screenUrl,
    poster: actor.imageUrl,
    durationMs: null,
    width: null,
    height: null,
  };
}

/** Whether Add Actors' actor has a video to preview. */
export function hasVideo(actor: PickedActor): actor is PickedActor & { videoUrl: string } {
  return actor.videoUrl !== null;
}
